export class AdvisorListItem {
  static fromJson(json: any): AdvisorListItem {
    return new AdvisorListItem(
      json.id,
      json.name,
      json.number,
      json.rate,
      json.rateTfa,
      json.active,
      json.payeeFirstName,
      json.payeeLastName,
      json.advisorTypeId,
      json.isRia
    );
  }

  static fromJsonArray(array): AdvisorListItem[] {
    return array.map(AdvisorListItem.fromJson);
  }

  constructor(
    public id: number,
    public name: string,
    public number: number,
    public rate: number,
    public rateTfa: number | null,
    public active: boolean,
    public payeeFirstName: string,
    public payeeLastName: string,
    public advisorTypeId: number,
    public isRia: boolean
  ) {}
}

export class AdvisorResponse {
  public advisors: AdvisorListItem[];
  public total: number;
}

export class Advisor {
  static fromJson(json: any): Advisor {
    return new Advisor(
      json.id,
      json.number,
      json.paymentMethod,
      json.rate,
      json.rateTfa,
      json.payeeFirstName,
      json.payeeLastName,
      json.bonusShared,
      json.userId,
      json.sharedBonusUserId,
      json.sharedBonusPercentage,
      json.partners || [],
      json.advisorTypeId,
      json.isRia
    );
  }

  static fromJsonArray(array): Advisor[] {
    return array.map(Advisor.fromJson);
  }

  constructor(
    public id: number,
    public number: number,
    public paymentMethod: number,
    public rate: number,
    public rateTfa: number,
    public payeeFirstName: string,
    public payeeLastName: string,
    public bonusShared: boolean,
    public userId: number,
    public sharedBonusUserId: boolean,
    public sharedBonusPercentage: number,
    public partners: number[],
    public advisorTypeId: number,
    public isRia: boolean
  ) {}
}
